import React, { useCallback } from 'react';

import { Link } from 'react-router-dom';
import { Button, IconButton } from '@material-ui/core';
import { MdEdit } from 'react-icons/md';

import API from 'utils/api';
import { useSources } from 'hooks';
import { ButtonContainer, Table, Tooltip } from 'components';
import { hasAnyRole } from 'utils/credentials';
import { ROLES } from 'consts';

import styles from './Users.module.scss';

const GroupList = () => {
  const sources = useSources();

  const fetchData = useCallback(
    ({ search, ...rest }) => {
      const filter = { $regex: search, $options: 'i' };

      return API.getGroups(
        {
          ...rest,
          query: search
            ? JSON.stringify({ $or: [{ name: filter }, { description: filter }] })
            : undefined,
          select: 'name description myRoles',
        },
        sources
      );
    },
    [sources]
  );

  return (
    <div className={styles.panel}>
      <ButtonContainer position="top">
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/dashboard/users/group"
        >
          create new group
        </Button>
      </ButtonContainer>

      <Table
        columns={[
          {
            title: 'Name',
            field: 'name',
            defaultSort: 'desc',
            weight: 2,
          },
          { title: 'Description', field: 'description', weight: 3 },
          {
            title: 'Actions',
            sorting: false,
            align: 'center',
            render: ({ _id, myRoles }) => (
              <div style={{ textAlign: 'center' }}>
                <IconButton
                  disabled={
                    !hasAnyRole([ROLES.USERS, ROLES.ADMIN, ROLES.SUPERADMIN], myRoles)
                  }
                  color="primary"
                  component={Link}
                  to={{
                    pathname: `/dashboard/users/group/${_id}`,
                    state: { actionMode: 'edit' },
                  }}
                >
                  <Tooltip title="Edit group" placement="top">
                    <MdEdit />
                  </Tooltip>
                </IconButton>
              </div>
            ),
          },
        ]}
        data={fetchData}
      />
    </div>
  );
};

export default GroupList;
